<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="手机号">
                <el-input
                    v-model="queryForm.phone"
                    placeholder="请输入手机号"
                    style="width: 200px"
                    clearable
                    maxlength="11"
                >
                    <span slot="suffix" class="phone-count">{{ queryPhoneLength }}/11</span>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" :loading="queryLoading" @click="getAgentTransferLimitList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>

        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-plus"
                        @click="showDialog = true"
                    >新增</el-button>
                </div>
                <div class="icon-group">
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshAgentTransferLimitList"
                    >
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="agentTransferLimitList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size="small"
            >
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="userPhone"
                    label="用户手机号"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="agentName"
                    label="代理名称"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="limitMoney"
                    label="限制金额"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createUserPhone"
                    label="创建人手机号"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="deleteAgentTransferLimit(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/编辑 -->
            <el-dialog
                title="新增"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="agentTransferLimit"
                        ref="agentTransferLimitForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="手机号"
                            prop="userPhone"
                        >
                            <el-input
                                v-model="agentTransferLimit.userPhone"
                                placeholder="请输入手机号"
                                style="width: 200px"
                                maxlength="11"
                            >
                                <span slot="suffix" class="phone-count">{{ phoneLength }}/11</span>
                            </el-input>
                        </el-form-item>
                        <el-form-item
                            label="金额"
                            prop="limitMoney"
                        >
                            <el-input
                                v-model="agentTransferLimit.limitMoney"
                                placeholder="请输入金额"
                                style="width: 200px"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
        
                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
  
<script>
import { Refresh, Search } from '@v2icons/tabler';
import { Delete24Regular } from '@v2icons/fluent';
import { get, postJson } from '@/utils/request.js';

export default {
    components: {
        Delete24Regular,
        Refresh,
        Search
    },
    data() {
        return {
            queryForm: {
                phone: '', // 手机号
            },
            loading: false,
            queryLoading: false, // 查询按钮loading状态
            showDialog: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            agentTransferLimitList: [],
            agentTransferLimit: {
                userPhone: '', // 手机号
                limitMoney: '', // 金额
            },
            rules: {
                userPhone: [
                    { required: true, message: '手机号不能为空', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                limitMoney: [
                    { required: true, message: '金额不能为空', trigger: 'blur' },
                    { 
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback();
                                return;
                            }
                            const numValue = Number(value);
                            if (isNaN(numValue)) {
                                callback(new Error('金额必须为数字'));
                            } else if (numValue < 0) {
                                callback(new Error('金额必须大于等于0'));
                            } else {
                                callback();
                            }
                        }, 
                        trigger: 'blur' 
                    }
                ],
            },
        };
    },
    computed: {
        phoneLength() {
            return this.agentTransferLimit.userPhone ? this.agentTransferLimit.userPhone.length : 0;
        },
        queryPhoneLength() {
            return this.queryForm.phone ? this.queryForm.phone.length : 0;
        }
    },
    created() {
        this.getAgentTransferLimitList();
    },
    methods: {
        // 搜索box
        search() {
            this.isSearch = !this.isSearch;
        },
        resetAgentTransferLimitList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.agentTransferLimitList = [];
        },
        resetDialog() {
            this.queryForm.phone = '';
        },
        closeDialog() {
            this.showDialog = false;
            this.agentTransferLimit = {
                userPhone: '',
                limitMoney: '',
            };
            this.$refs.agentTransferLimitForm && this.$refs.agentTransferLimitForm.resetFields();
        },
        submitForm() {
            this.agentTransferLimit.limitMoney = Number(this.agentTransferLimit.limitMoney);
            this.$refs.agentTransferLimitForm.validate((valid) => {
                if (valid) {
                    postJson(`/agentLimit/insert`, { ...this.agentTransferLimit }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000,
                            });
                            this.resetAgentTransferLimitList();
                            this.closeDialog();
                            this.getAgentTransferLimitList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },
        // 删除
        deleteAgentTransferLimit(id) {
            this.$msgbox({
                title: '提示',
                message: '确定删除所选项吗？',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除中...';
                        get(`/agentLimit/updateById`, { id: id }).then((res) => {
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = '确定';
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetAgentTransferLimitList();
                                this.getAgentTransferLimitList();
                                done();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                                done();
                            }
                        }).catch((err) => {
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = '确定';
                            this.$message({
                                message: err.response?.data?.msg || '删除失败',
                                type: 'error',
                                duration: 2000
                            });
                            done();
                        });
                    } else {
                        done();
                    }
                }
            }).catch(() => {});
        },
        refreshAgentTransferLimitList() {
            this.resetAgentTransferLimitList();
            this.getAgentTransferLimitList();
        },
        // 获取列表信息
        getAgentTransferLimitList() {
            this.loading = true;
            this.queryLoading = true;
            get(`/agentLimit/list`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                this.queryLoading = false;
                if (res.success) {
                    this.agentTransferLimitList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            }).catch((err) => {
                this.loading = false;
                this.queryLoading = false;
                this.$message({
                    message: err.response?.data?.msg || '查询失败',
                    type: 'error',
                    duration: 2000
                });
            });
        },
        currentChange(page) {
            this.currentPage = page;
            this.getAgentTransferLimitList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getAgentTransferLimitList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.count{
    font-size: 14px;
    margin-left: 10px;
    padding: 0 4px;
}
.phone-count {
    font-size: 11px;
    color: #409eff;
    padding-right: 8px;
    white-space: nowrap;
}
</style>

